if (!customElements.get('sale-countdown')) {
  class SaleCountdown extends HTMLElement {
    connectedCallback() {
      this.end = new Date(this.dataset.end).getTime();
      this.units = {
        days: this.querySelector('[data-unit="days"]'),
        hours: this.querySelector('[data-unit="hours"]'),
        minutes: this.querySelector('[data-unit="minutes"]'),
        seconds: this.querySelector('[data-unit="seconds"]')
      };

      if (Number.isNaN(this.end)) {
        this.hide();
        return;
      }

      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    tick() {
      const remaining = this.end - Date.now();

      if (remaining <= 0) {
        clearInterval(this.timer);
        this.hide();
        return;
      }

      const days = Math.floor(remaining / 86400000);
      const hours = Math.floor((remaining % 86400000) / 3600000);
      const minutes = Math.floor((remaining % 3600000) / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);
      const pad = (value) => String(value).padStart(2, '0');

      this.units.days.textContent = pad(days);
      this.units.hours.textContent = pad(hours);
      this.units.minutes.textContent = pad(minutes);
      this.units.seconds.textContent = pad(seconds);
    }

    hide() {
      this.hidden = true;
    }
  }

  customElements.define('sale-countdown', SaleCountdown);
}
